import { render, staticRenderFns } from "./BasicOverlay.vue?vue&type=template&id=6a1eef6b&scoped=true"
import script from "./BasicOverlay.vue?vue&type=script&lang=ts"
export * from "./BasicOverlay.vue?vue&type=script&lang=ts"
import style0 from "./BasicOverlay.vue?vue&type=style&index=0&id=6a1eef6b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1eef6b",
  null
  
)

export default component.exports